import React from "react";
import { exm_file, warning, warning_2, warning_3 } from "../texts/fill";
import { useExportFile } from "../hook/use_export_file";
import "./DownloadExample.css";

const DownloadExample = () => {
    const { handleExport } = useExportFile();

    return (
        <div className="download-example">
            <div className="alert alert-danger">
                <h5>{warning_2}</h5>
                <p>{warning_3}</p>
            </div>
            <div className="download-container">
                <button onClick={handleExport} className="btn btn-info download-btn">
                    {exm_file}
                    <img src="downloads.png" alt="Download" className="download-icon" />
                </button>
                <div className="alert alert-warning warning-box">
                    {warning}
                    <img src="warning.png" alt="Warning" className="warning-icon" />
                </div>
            </div>
        </div>
    );
};

export default DownloadExample;
